const FOOTER_ELEMENTS = [{
  text: {
    options: {
      x: 0.74,
      y: 6.89,
      h: 0.118,
      w: 2.531,
      fontFace: 'Arial',
      fontSize: 7,
      bold: true,
    },
    text: 'RESTRICTED DISTRIBUTION',
  },
},
{
  text: {
    options: {
      x: 0.74,
      y: 7.04,
      w: 4.6,
      h: 0.169,
      fontFace: 'Arial',
      fontSize: 7,
    },
    text: `© ${new Date().getFullYear()} Gartner, Inc. and/or its affiliates. All rights resered.`,
  },
},
{
  image: {
    path: `${process.env.PUBLIC_URL}/ppt/gartner-dark.png`,
    h: 0.318,
    w: 1.401,
    x: 11.433,
    y: 6.826,
  },
}];

const SlideConstants = {
  MASTER_SLIDE_WITH_TITLE: {
    title: 'MASTER_WITH_TITLE',
    slideNumber: {
      x: 0.51,
      y: 6.97,
      fontFace: 'Arial',
      fontSize: 10,
    },
    objects: [
      ...FOOTER_ELEMENTS,
      {
        rect: {
          fill: {
            color: '002856',
          },
          x: 0,
          y: 1.48,
          w: 1.92126,
          h: 3.598,
        },
      },
      {
        rect: {
          fill: {
            color: '002856',
          },
          x: 7.811,
          y: 1.48,
          w: 5.519,
          h: 3.598,
        },
      },
    ],
  },
  MASTER_SLIDE_WITH_TITLE_PINK: {
    title: 'MASTER_WITH_TITLE_PINK',
    slideNumber: {
      x: 0.51,
      y: 6.97,
      fontFace: 'Arial',
      fontSize: 10,
    },
    objects: [
      ...FOOTER_ELEMENTS,
      {
        rect: {
          fill: {
            color: 'E81059',
          },
          x: 0,
          y: 1.48,
          w: 1.92126,
          h: 3.598,
        },
      },
      {
        rect: {
          fill: {
            color: 'E81059',
          },
          x: 7.811,
          y: 1.48,
          w: 5.519,
          h: 3.598,
        },
      },
    ],
  },
  MASTER_BASE_SLIDE: {
    title: 'MASTER_BASE',
    slideNumber: {
      x: 0.51,
      y: 6.97,
      fontSize: 10,
    },
    objects: [
      ...FOOTER_ELEMENTS,
    ],
  },
  HERO: {
    title: 'HERO',
    objects: [
      {
        image: {
          path: `${process.env.PUBLIC_URL}/ppt/hero.png`,
          x: 0,
          y: 0,
          w: 13.334,
          h: 7.5,
        },
      },
      {
        rect: {
          h: 4.082,
          w: 6.681,
          x: 1.472,
          y: 1.255,
          fill: {
            color: '000000',
            transparency: 40,
          },
        },
      },
      {
        text: {
          options: {
            x: 0.35,
            y: 6.708,
            h: 0.118,
            w: 7.763,
            fontSize: 7,
            fontFace: 'Arial',
            color: 'ffffff',
          },
          text: `© ${new Date().getFullYear()} Gartner, Inc. and/or its affiliates. All rights reserved. Gartner is a registered trademark of Gartner, Inc. and its affiliates. This presentation, including all supporting materials, is proprietary to Gartner, Inc. and/or its affiliates and is for the sole internal use of the intended recipients. Because this presentation may contain information that is confidential, proprietary or otherwise legally protected, it may not be further copied, distributed or publicly displayed without the express written permission of Gartner, Inc. or its affiliates.`,
        },
      },
      {
        image: {
          path: `${process.env.PUBLIC_URL}/ppt/gartner-light.png`,
          h: 0.507,
          w: 2.2,
          x: 10.618,
          y: 6.539,
        },
      },
      {
        rect: {
          x: 1.736,
          y: 1.468,
          h: 3.598,
          w: 0.177,
          fill: {
            color: 'E81059',
          },
        },
      },
      {
        rect: {
          x: 7.72,
          y: 1.468,
          h: 3.598,
          w: 0.177,
          fill: {
            color: 'E81059',
          },
        },
      },
    ],
  },
};

export default SlideConstants;
